import * as z from "zod";

export const submitMerchantFeedback = {
  name: "submitMerchantFeedback" as const,
  input: z.object({
    comment: z.string().trim().min(1).max(500),
    pageUrl: z.string().max(2000).optional(),
  }),
  output: z.object({
    success: z.literal(true),
    // The persisted feedback row id, returned so the client can attach a
    // follow-up answer to it. Null when the feedback was not persisted (team
    // without a linked account). Optional so an older client validating against
    // a pre-follow-up schema (or a new client hitting an older server during a
    // deploy window) degrades gracefully instead of failing validation.
    feedbackId: z.string().nullable().optional(),
    // When true, the client should show the follow-up step with the question
    // below, then call submitMerchantFeedbackFollowUp. The Slack notification
    // is held until that call so it can include the answer. Absent/false means
    // skip the follow-up step.
    needsFollowUp: z.boolean().optional(),
    followUpQuestion: z.string().nullable().optional(),
  }),
};
